import { apiRequest } from "./apiClient";

// SuperAdmin paneli — "Mail Sistemi Testi" bölümü için.
// Backend tarafı sadece SuperAdmin'e izin verir (requireSuperAdmin); burada
// ayrıca bir yetki kontrolü yapmıyoruz, UI tarafında zaten superAdminMi
// kontrolüyle gizleniyor.
export async function testMailGonder({ to, lang } = {}) {
  return apiRequest("/auth/admin/test-email", {
    method: "POST",
    body: JSON.stringify({ to: to || undefined, lang: lang || undefined }),
  });
}

export async function mailMetrikleriniGetir(days = 30) {
  return apiRequest(`/auth/admin/email-metrics?days=${encodeURIComponent(days)}`, {
    method: "GET",
  });
}
